import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import FrontVideo from "../../components/homevideo";
import HeaderTitle from "../../components/headerTitle";
import ClientExperiences from "../../components/home/client-experiences";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";
import WhatWeOffer from "../../components/CommonSections/WhatWeOffer";
import Advantage from "../../components/CommonSections/Advantage";
import PageLoader from "../../components/home/pageload";
import MetaTag from "../../components/CommonSections/MetaTag";
import ImgSmartCity from "../../assest/images/IshanSmartCity.png";
import { Link } from "react-router-dom";
import SubServiceSchema from "../../components/CommonSections/subServicesSchema";
import ColocationPopup from "../../components/colocation-popup";
import ColocationBannerForm from "../../components/colocation-banner-from";
import Accordion from '../../components/accordion';
import {
     Input,
     FormFeedback,
     Form, 
     Modal,
     ModalBody,
   } from "reactstrap";

export default function ColocationChennaiFun() {
     const handleClick = () => {
          window.scrollTo(0, 0);
     }

     const [ColocationChennai, setColocationChennai] = useState(null);
     const [settingResponse, setSettingResponse] = useState(null);
     const [getInTuchPlanModal, setInTuchPlanModal] = useState(false);

     useEffect(() => {
          const requestData = {  
               "service_tag": "colocation_chennai"
          };

          axios.post(`${API_BASE_URL}/api/smartcity/getsmartCity`, requestData).then((response) => {
               setColocationChennai(response);
               const generalSettingsData = response?.data?.data?.general_settings?.general_settings_data;
               const networkServicesSettingsData = generalSettingsData.find((item) => item.tag === "smart_city_advantage") || null;
               const networkServicesSettingsResponse = JSON.parse(networkServicesSettingsData?.response || "{}");

               networkServicesSettingsResponse.advantages = networkServicesSettingsResponse;
               setSettingResponse(networkServicesSettingsResponse);
          }).catch((error) => { 
               <PageLoader />
          })
     }, [])

     const [modal, setModal] = useState(false);
     const [colocationData, setcolocationData] = useState(null);
     const toggle = () => {
       if (modal) {
         setModal(false);
       } else {
         setModal(true);
       }
     };

     const openModal = (colocationData) => {
       setModal(true);
       setcolocationData(colocationData);
     };

     // ────────────────────────────────────────────────
     // LocalBusiness Schema
     // ────────────────────────────────────────────────
     const localBusinessSchema = {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "address": {
               "@type": "PostalAddress",
               "addressLocality": "chennai",
               "addressRegion": "TN",
               "streetAddress": "5th Floor, Door No. 74, Fagun Mansion, Ethiraj Salai, Egmore"
          },
          "description": "Reliable colocation services in Chennai by Ishan Technologies. Ensure secure, scalable, and high-performance data center solutions for your business needs",
          "name": "Ishan Technologies",
          "telephone": "+91 28166-47426"
     };
     console.log("LocalBusiness Schema for Chennai Colocation:", localBusinessSchema);

     // ────────────────────────────────────────────────
     // FAQ Schema
     // ────────────────────────────────────────────────
     const faqSchemaChennai = {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          mainEntity: [
               {
                    "@type": "Question",
                    name: "What is colocation and why should I consider it for my business?",
                    acceptedAnswer: {
                         "@type": "Answer",
                         text: "Colocation is leasing space in a data center to house servers and IT equipment. It offers benefits like enhanced security, reliable power and cooling, high-speed internet connectivity, and scalability. You can consider it to reduce infrastructure costs, ensure uptime, and focus on core business activities while leveraging professional data center management services."
                    }
               },
               {
                    "@type": "Question",
                    name: "What makes Ishan Technologies' colocation services in Chennai stand out?",
                    acceptedAnswer: {
                         "@type": "Answer",
                         text: "Ishan Technologies' colocation services in Chennai stand out due to their state-of-the-art infrastructure featuring seamless network connectivity, redundant power and cooling. Additionally, we offer 24/7 support, advanced security measures, customisable solutions, and strategic location advantages, providing businesses with reliable, scalable, and cost-effective hosting solutions."
                    }
               },
               {
                    "@type": "Question",
                    name: "Can I customise my colocation setup according to my specific requirements?",
                    acceptedAnswer: {
                         "@type": "Answer",
                         text: "Yes, at Ishan Technologies, we understand that every business has unique needs. That's why we offer customised solutions in Chennai. You can tailor your setup according to your requirements, including space, power, connectivity, and compliance needs, ensuring optimal performance and cost-effectiveness for your business."
                    }
               },
               {
                    "@type": "Question",
                    name: "How secure is Ishan Technologies' colocation facility in Chennai?",
                    acceptedAnswer: {
                         "@type": "Answer",
                         text: "We prioritise security with advanced measures like access controls, surveillance, and environmental monitoring, ensuring the protection of your valuable data and infrastructure."
                    }
               },
               {
                    "@type": "Question",
                    name: "What support services are available for clients utilising Ishan Technologies' colocation in Chennai?",
                    acceptedAnswer: {
                         "@type": "Answer",
                         text: "Clients utilising Ishan Technologies' colocation in Chennai benefit from 24/7 support services, including technical assistance, maintenance, and troubleshooting, ensuring continuous operation and peace of mind for their critical IT infrastructure."
                    }
               },
               {
                    "@type": "Question",
                    name: "What certifications does Ishan Technologies' colocation facility in Chennai hold?",
                    acceptedAnswer: {
                         "@type": "Answer",
                         text: "Ishan Technologies' colocation facility in Chennai holds ISO 9001, ISO 27001, and CMMI Level 3 certifications, demonstrating compliance with international standards for quality management, information security, and process maturity."
                    }
               }
          ]
     };

     return (
          <>
               {ColocationChennai === null ? (
                    <PageLoader />
               ) : (
                    <>
                         {/* ── JSON-LD Schema Markup ── */}
                         <Helmet>
                              <script type="application/ld+json">
                                   {JSON.stringify(localBusinessSchema)}
                              </script>
                         </Helmet>

                         <SubServiceSchema 
                              title={ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.title} 
                              url='https://ishantechnologies.com/systems-integration/smart-city-services' 
                              parentTitle='System Integration' 
                              parentUrl='https://ishantechnologies.com/systems-integration' 
                         />
                         <MetaTag data={ColocationChennai} pageKey="smart_city"/>

                         <div className="page_heading responsive_heading">
                              <div className="container">
                                   <HeaderTitle headerTitledata={ColocationChennai} pageKey="smart_city" />
                              </div>
                         </div>

                         <div 
                              className={`video hero-banner internet-banner ${
                                   !ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.banner_title &&
                                   !ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.banner_img_desc
                                        ? 'no-content' 
                                        : ''
                              }`}
                         >
                              <FrontVideo homeData={ColocationChennai} pageKey="smart_city" />
                              <div className="banner-content ">
                                   <div className="content-blk">
                                        {ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.banner_title && (
                                             <h2 className='home-heading'>
                                                  {ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.banner_title}
                                             </h2>
                                        )}

                                        {ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.banner_img_desc && (
                                             <p className="para">
                                                  {ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.banner_img_desc}
                                             </p>
                                        )}

                                        {ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.button_img_name && (
                                             <a href={ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.button_url}>
                                                  <button className="button hero-btn">
                                                       {ColocationChennai?.data?.data?.smart_city?.smart_city_banner_data?.[0]?.button_img_name}
                                                  </button>
                                             </a>
                                        )}
                                   </div>
                                   <div className="form-blk">
                                        <ColocationBannerForm homeData={ColocationChennai} pageName="ColocationChennai" />
                                   </div> 
                              </div> 
                         </div>

                         <div className="empowering section-space spin-wrap">
                              <div className="spin-round-wrap">
                                   <div className="spin-round color-navy-blue">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>

                              <div className="container">
                                   <div className="empowering-inner">
                                        <div className="empowering-left">
                                             <img src={ImgSmartCity} alt="Smart City" height={60} width={60} loading="lazy"/>
                                        </div>
                                        <div className="empowering-right" dangerouslySetInnerHTML={{ __html: ColocationChennai?.data?.data?.smart_city?.smart_city_information_data?.[0]?.description }}>
                                        </div>
                                   </div>
                                   <div className="colocation_popup"> 
                                        <button className="button getintouch" onClick={() => openModal()}>Get In Touch</button>
                                   </div>
                              </div>

                              <div className="spin-round-wrap">
                                   <div className="spin-round">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>
                         </div>

                         <Modal isOpen={modal} toggle={toggle}>
                              <ModalBody>
                                   <Link className="close1" onClick={(e) => { e.preventDefault(); toggle(); }}>×</Link>
                                   <ColocationPopup colocationData={colocationData} pageName="ColocationChennai" />
                              </ModalBody>
                         </Modal>

                         <div className="weoffer-bgdark">
                              <WhatWeOffer 
                                   title={settingResponse?.what_we_offer} 
                                   data={ColocationChennai?.data?.data?.smart_city?.smart_city_offer_data} 
                              />
                         </div>

                         <Advantage 
                              title={settingResponse?.advantages} 
                              data={ColocationChennai?.data?.data?.smart_city?.smart_city_advantages_data} 
                              action='colocation' 
                              pageName="ColocationChennai" 
                         />

                         <div className="frequently section-space">
                              <div className="container">
                                   <h2 className="supercharge-heading">Frequently Asked Questions (FAQs)</h2>

                                   {/* Chennai FAQ Schema */}
                                   <script
                                        type="application/ld+json"
                                        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchemaChennai) }}
                                   />

                                   <Accordion items={ColocationChennai?.data?.data?.smart_city?.smart_city_services_faq_data} />
                              </div>
                         </div>

                         <div className="supercharge supercharge-left">
                              <div className="container">
                                   <h2 className="supercharge-heading" style={{marginBottom:'2px'}}>
                                        {ColocationChennai?.data?.data?.smart_city?.smart_city_cta_banner_data?.[0]?.title}
                                   </h2>
                                   <p style={{ color: '#fff' }}>
                                        Ready to revolutionise your infrastructure with Ishan Technologies' Colocation Services in Chennai? 
                                   </p>
                                   <div className="supercharge-btns">
                                        {ColocationChennai?.data?.data?.smart_city?.smart_city_cta_banner_data?.[0]?.button_title_1 &&
                                             <Link to={ColocationChennai?.data?.data?.smart_city?.smart_city_cta_banner_data?.[0]?.button_url_1}>
                                                  <button className="getintouch" onClick={handleClick}>
                                                       {ColocationChennai?.data?.data?.smart_city?.smart_city_cta_banner_data?.[0]?.button_title_1?.toUpperCase()}
                                                  </button>
                                             </Link>
                                        }
                                        {ColocationChennai?.data?.data?.smart_city?.smart_city_cta_banner_data?.[0]?.button_title_2 &&
                                             <Link to={ColocationChennai?.data?.data?.smart_city?.smart_city_cta_banner_data?.[0]?.button_url_2} target="_blank">
                                                  <button className="getintouch" onClick={handleClick}>
                                                       {ColocationChennai?.data?.data?.smart_city?.smart_city_cta_banner_data?.[0]?.button_title_2?.toUpperCase()}
                                                  </button>
                                             </Link>
                                        }
                                   </div>
                              </div>
                         </div>

                         <Modal isOpen={modal} toggle={toggle}>
                              <ModalBody>
                                   <Link className="close1" onClick={(e) => { e.preventDefault(); toggle(); }}>×</Link>
                                   <ColocationPopup colocationData={colocationData} pageName="ColocationChennai" />
                              </ModalBody>
                         </Modal>

                         <Modal isOpen={getInTuchPlanModal} toggle={() => setInTuchPlanModal(false)}>
                              <ModalBody>
                                   <Link className="close1" onClick={(e) => { e.preventDefault(); setInTuchPlanModal(false); }}>×</Link>
                                   <div className="Mobile_getin_tuch">
                                        <ColocationBannerForm homeData={colocationData} pageName="ColocationChennai" />
                                   </div>
                              </ModalBody>
                         </Modal>

                         <a 
                              href="javascript:void(0)" 
                              className="enquire-now-side-btn"  
                              onClick={(e) => { e.preventDefault(); setInTuchPlanModal(true); }}
                         >
                              GET IN TOUCH
                         </a>
                    </>
               )} 
          </>
     );
}